import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ROUTES } from "./routes/ROUTES";

const ROUTER = createBrowserRouter(ROUTES);

export function App(): JSX.Element {
  return <RouterProvider router={ROUTER} />;
}
